<template>
  <div
    :class="{ 'header-page-long' : !is_sidebar_minimized }"
    class="list-view-page"
  >
    <!-- General Section -->
    <div class="section-list">
      <div class="list-view">
        <div
          v-for="item in sectionGeneral"
          :key="item.id"
          :class="{ 'card-active': menuActive === item.id }"
          class="card-view"
          @click="changeView(item.id)"
        >
          <!-- If have been setup -->
          <img
            v-if="formDetail.name && menuActive === item.id && !changes_value_view"
            src="@/assets/new-form-ui/icon-active/check-circle-active.svg"
            class="icon-checked"
          >
          <img
            v-if="formDetail.name && menuActive !== item.id && !changes_value_view"
            src="@/assets/new-form-ui/icon/check-circle.svg"
            class="icon-checked"
          >

          <!-- IF editable view -->
          <img
            v-if="menuActive === item.id && changes_value_view"
            src="@/assets/new-form-ui/editable.svg"
            class="icon-checked"
          >
          <img
            v-if="formDetail.name && menuActive !== item.id && changes_value_view"
            src="@/assets/new-form-ui/icon/check-circle.svg"
            class="icon-checked"
          >

          <!-- Icon Menu -->
          <img
            v-if="menuActive === item.id"
            :src="require(`@/assets/new-form-ui/icon-active/${item.icon}.svg`)"
            class="icon-view"
          >
          <img
            v-else
            :src="require(`@/assets/new-form-ui/icon/${item.icon}.svg`)"
            class="icon-view"
          >
          <span>
            {{ item.name }}
          </span>
        </div>
      </div>
    </div>

    <div class="line"/>

    <!-- View Section -->
    <div class="section-list">
      <div class="list-view">
        <div
          v-for="item in sectionView"
          :key="item.id"
          :class="{
            'mr-4': item.id === 'calendar' || item.id === 'detail',
            'card-active': menuActive === item.id,
            'disabled': !formDetail.type
          }"
          class="card-view"
          @click="changeView(item.id)"
        >
          <!-- If have been setup -->
          <img
            v-if="formDetail[item.key] && menuActive === item.id && !changes_value_view"
            src="@/assets/new-form-ui/icon-active/check-circle-active.svg"
            class="icon-checked"
          >
          <img
            v-if="formDetail[item.key] && menuActive !== item.id && !changes_value_view"
            src="@/assets/new-form-ui/icon/check-circle.svg"
            class="icon-checked"
          >

          <!-- IF editable view -->
          <img
            v-if="menuActive === item.id && changes_value_view"
            src="@/assets/new-form-ui/editable.svg"
            class="icon-checked"
          >
          <img
            v-if="formDetail[item.key] && menuActive !== item.id && changes_value_view"
            src="@/assets/new-form-ui/icon/check-circle.svg"
            class="icon-checked"
          >

          <!-- Icon Menu -->
          <img
            v-if="menuActive === item.id"
            :src="require(`@/assets/new-form-ui/icon-active/${item.icon}.svg`)"
            class="icon-view"
          >
          <img
            v-else
            :src="require(`@/assets/new-form-ui/icon/${item.icon}.svg`)"
            class="icon-view"
          >
          <span>
            {{ item.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    sectionGeneral: {
      type: Array,
      default: () => [],
    },
    sectionView: {
      type: Array,
      default: () => [],
    },
    menuActive: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState('jStoreFormUi', ['changes_value_view']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },

  methods: {
    changeView(view) {
      if (this.formDetail.type) this.$emit('change-view', view);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/ListView.vue